import ModalAdmin from './ModalAdmin';

export default ModalAdmin;
